module.exports = __webpack_public_path__ + "img/neeli.8d1379c3.png";